import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import AddMemberForm from '@components/MasterAccount/AddMemberForm';

const AddMemberModal = ({ isOpen, handleClose, tabProps }) => {
  return (
    <Modal
      backdrop="static"
      isOpen={isOpen}
      toggle={handleClose}
      centered
      autoFocus
      className="add-member-modal"
    >
      <ModalHeader toggle={handleClose}>
        <FormattedMessage id="navigation.master.connect" defaultMessage="Добавить участника" />
      </ModalHeader>

      <ModalBody>
        <AddMemberForm key="AddMemberForm" tabProps={tabProps} handleClose={handleClose} />
      </ModalBody>
    </Modal>
  );
};

export default AddMemberModal;
